import {useHBStore} from 'hb-redux-store/root.hooks.js';

import {
  getPDPDetails,
  resetPDP,
  notifyUser,
  getRandomSection,
} from 'hb-redux-store/feature/products/product.action';

import {selectPDPDetails} from 'hb-redux-store/feature/products/product.selectors';

export const usePDPDetails = () => {
  const {state, dispatch} = useHBStore();
  const productDetails = selectPDPDetails(state);
  return {
    productDetails,
    getPDPDetails: productId => dispatch(getPDPDetails(productId)),
    resetPDP: () => dispatch(resetPDP()),
    notifyUser: payload => dispatch(notifyUser(payload)),
    getRandomSection: payload => dispatch(getRandomSection(payload)),  
  };
};
